// GamePassDirect — vidéo de fond du hero. Zéro octet vidéo tant que la page n'est pas chargée et au repos (LCP protégé par le poster).
// Pas de lecture : reduced-motion, économiseur de données, connexion 2G/3G, ou mobile si désactivé dans le réglage.
import { prefersReducedMotion } from './vyrl.js';

const video = document.querySelector('.vyrl-hero__bg-video');

if (video) {
  const conn = navigator.connection;
  const slow = conn && (conn.saveData || /2g|3g/.test(conn.effectiveType || ''));
  const mobile = window.matchMedia('(max-width: 749px)').matches;

  if (!prefersReducedMotion() && !slow && !(mobile && video.dataset.mobile !== 'true')) {
    let started = false;
    let visible = true;

    const sync = () => {
      if (!started) return;
      if (visible && !document.hidden) {
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
      } else {
        video.pause();
      }
    };

    const start = () => {
      started = true;
      video.muted = true;
      video.src = (mobile && video.dataset.srcMobile) || video.dataset.srcDesktop;
      video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
      sync();
    };

    // Démarrage différé : première interaction (scroll/toucher/clavier) ou, à défaut, 6 s après le chargement.
    // La vidéo ne concurrence ainsi ni le LCP ni le thread principal pendant le premier rendu.
    const whenIdle = () => ('requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 3000 }) : setTimeout(start, 1500));
    const events = ['scroll', 'pointerdown', 'touchstart', 'keydown'];
    let armed = false;
    const trigger = () => {
      if (armed) return;
      armed = true;
      events.forEach((name) => window.removeEventListener(name, trigger));
      whenIdle();
    };
    const arm = () => {
      events.forEach((name) => window.addEventListener(name, trigger, { once: true, passive: true }));
      setTimeout(trigger, 6000);
    };
    if (document.readyState === 'complete') arm();
    else window.addEventListener('load', arm, { once: true });

    document.addEventListener('visibilitychange', sync);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; sync(); }).observe(video.closest('.vyrl-hero') || video);
    }
  }
}
